import styled, { css } from 'styled-components';

// ** Utils
import { pxToRem } from 'utils/transform-px.utils';

// ** Components
import { LogoBackgroundStyled } from 'components/logo-background/logo-background.styled';

export const AboutStyled = styled.section`
  padding: ${pxToRem(100)} ${pxToRem(101)} ${pxToRem(100)};
  position: relative;
  ${LogoBackgroundStyled} {
    width: ${pxToRem(610)};
    right: ${pxToRem(40)};
    background-position-y: ${pxToRem(-100)};
    left: auto;
  }
  ${(props) =>
    props.theme.media.down(
      'md',
      css`
        padding: ${pxToRem(100)} ${pxToRem(80)} ${pxToRem(80)};
        ${LogoBackgroundStyled} {
          display: none;
        }
      `
    )}
  ${(props) =>
    props.theme.media.down(
      'sm',
      css`
        padding: ${pxToRem(45)} ${pxToRem(40)};
      `
    )}
`;

export const DescriptionWrapper = styled.div`
  max-width: ${pxToRem(823)};

  ${(props) =>
    props.theme.media.down(
      'md',
      css`
        max-width: ${pxToRem(461)};
      `
    )}
`;
